export const SUMMARY_STATUS = {
  GENERATING: 1,
  SUCCESS: 2,

  1: '转写中',
  2: '转写完成'
};

// 小会议纪要翻译语言
export const translateLanguageList = [
  { label: 'translate.no_translate', value: 'SOURCE' },
  { label: 'common.noun.zh_cn', value: 'CHINESE' },
  { label: 'common.noun.en_us', value: 'ENGLISH' },
  { label: 'common.noun.japanese', value: 'JAPANESE' },
  { label: 'common.noun.german', value: 'GERMAN' },
  { label: 'common.noun.french', value: 'FRENCH' }
];

export const languageMap = translateLanguageList.reduce((acc, item) => {
  acc[item.value] = item.value;
  return acc;
}, {});

/**
 * 原文翻译转化状态
 */
export const TranslationCompletionStatus = {
  /**
   * 未翻译
   */
  NotTranslated: 0,
  /**
   * 翻译中
   */
  Translating: 1,
  /**
   * 已完成
   */
  Completed: 2,
  /**
   * 已失败
   */
  Failed: 3
};

// 译文显示状态
export const displayLanguageList = [
  { label: 'common.noun.original', value: 'ORIGINAL', exportCode: '' },
  { label: 'common.noun.bilingual', value: 'BILINGUAL', exportCode: '1' },
  { label: 'report.translated_text', value: 'TRANSLATED', exportCode: '0' }
];

export const displayMap = displayLanguageList.reduce((acc, item) => {
  acc[item.value] = item.value;
  return acc;
}, {});

export const SUMMARY_TYPE_MAP = {
  OPEN_MEMBERSHIP: 2,
  PAY_COIN: 3
};
